// extracted by mini-css-extract-plugin
module.exports = {"product-menu":"Menu_product-menu__1Si7O"};